export default {
    title_list: 'Tags',
    title_page: 'Tag',
    title_create_page: 'Create tag',
    title_edit_page: 'Change tag',

    filter: {
        labels: {
            title: 'Title',
            activated: 'Activated',
        }
    },

    table: {
        labels: {
            id: 'ID',
            title: 'Title',
            user_id: 'Members count',
            activated: 'Activated',
        }
    },

    buttons: {

    },

    form: {
        title: 'Title',
        user_id: 'User',
        activated: 'Activated',
    },
}
